import { render } from "./CourseExamList.vue?vue&type=template&id=5ac48abd&scoped=true"
import script from "./CourseExamList.vue?vue&type=script&lang=js"
export * from "./CourseExamList.vue?vue&type=script&lang=js"

import "./CourseExamList.vue?vue&type=style&index=0&id=5ac48abd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac48abd"]])

export default __exports__